module.exports = __webpack_public_path__ + "static/img/easy-to-get-started.71c09e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/easy-to-get-started.png
// module id = 0l0/
// module chunks = 0